import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import approveIcon from "../../../../../assets/icons/approve-tick-icon.svg";
import rejectIcon from "../../../../../assets/icons/reject-request-icon.svg";
import "./approve-or-reject-popup.scss";

interface ApproveOrRejectRequestProps {
  title: string;
  open: boolean;
  onCancel: () => void;
  onOkay?: () => void;
  onReject?: (val: string) => void;
  note: string;
  buttonText: string;
  cancelBtnText?: string;
  fieldName?: string;
  isInputRequired?: boolean;
  iconSrc?: string;
}

const ApproveOrRejectRequestPopup: React.FC<ApproveOrRejectRequestProps> = ({
  title,
  open,
  onCancel,
  onOkay,
  note,
  buttonText,
  cancelBtnText = "Cancel",
  fieldName,
  isInputRequired = false,
  onReject,
  iconSrc
}) => {
  const [rejectReason, setRejectReason] = useState<string>("");
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (open) {
      setRejectReason("");
      setError("");
    }
  }, [open]);
  return (
    <>
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            onCancel();
          }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={`approve-or-reject-popup-wrapper`}
      >
        <DialogTitle id="alert-dialog-title">
          <div className="header-wrapper">
            <div className="image-wrapper">
              {fieldName === "approve" ? (
                <img src={iconSrc || approveIcon} className="approve-icon"></img>
              ) : (
                <img src={rejectIcon} className="reject-icon"></img>
              )}
            </div>
           
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <p className="title-content">{title}</p>
            <p className="desc-content">{note}</p>
            {fieldName === "reject" && isInputRequired && (
              <>
                <textarea
                  className="reject-reason-textarea"
                  placeholder="Please provide reason for rejection."
                  onChange={(e) => {
                    setRejectReason(e.target.value);
                    setError("");
                  }}
                  minLength={5}
                  maxLength={500}
                ></textarea>
                {error && <div className="error-message">{error}</div>}
              </>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel} className="cancel-btn" type="button">
            {cancelBtnText || "Cancel"}
          </Button>

          <Button
            onClick={
              fieldName === "approve"
                ? onOkay
                : () => {
                    if (
                      rejectReason.trim().length >= 5 &&
                      rejectReason.trim().length <= 500
                    ) {
                      onReject?.(rejectReason);
                    } else if (rejectReason.trim().length <= 5) {
                      setError(
                        "Rejection reason must be at least 5 characters"
                      );
                    } else if (rejectReason.trim().length > 500) {
                      setError(
                        "Rejection reason must be less than 500 characters"
                      );
                    }
                  }
            }
            autoFocus
            className={`action-btn ${fieldName === "approve" ? "approve-btn" : "reject-btn"}`}
            disabled={
              fieldName === "reject" &&
              isInputRequired &&
              rejectReason.trim() === ""
            }
            type="button"
          >
            {buttonText}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ApproveOrRejectRequestPopup;
